import React from 'react';
import { makeStyles } from '@mui/styles';
import { TableRow, TableCell } from '@mui/material';
import NutrientRangeSlider from '../../NutrientRangeSlider/NutrientRangeSlider';
import NutrientItemTitle from './NutrientItemTitle';
import { NUTRIENT_KEYS } from '../../../lib/constants/constants';
import { NUTRIENT_TABLE_CONSTANTS } from '../utils/nutrientTableConstants';

const { DESKTOP_COLUMN_WIDTHS } = NUTRIENT_TABLE_CONSTANTS;

const useStyles = makeStyles((theme) => ({
  tableRow: {
    height: '60px',
    paddingTop: '16px',
    display: 'flex',
    width: '806px',
    '& td': {
      borderBottom: 'none',
    },
  },
  tableBody: {
    paddingTop: '16px',
  },
  tableHead: {
    marginBottom: '16px',
  },
  unitRegular: theme.globalClasses.unitRegular,
  unitBold: theme.globalClasses.unitBold,
  cellContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  cellContentCentered: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  slidersContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '7px',
    alignItems: 'center',
    width: '100%',
  },
  nutrientCell: {
    ...DESKTOP_COLUMN_WIDTHS.nutrient,
  },
  currentCell: {
    ...DESKTOP_COLUMN_WIDTHS.current,
  },
  goalCell: {
    ...DESKTOP_COLUMN_WIDTHS.goal,
  },
  changeCell: {
    ...DESKTOP_COLUMN_WIDTHS.change,
  },
  sliderCell: {
    ...DESKTOP_COLUMN_WIDTHS.slider,
  },
}));

const getCell = ({ data, unit = '', type = '' }) => {
  const classes = useStyles();

  // If data is 0 or empty, don't show anything
  if (!data && data !== 0) {
    return <TableCell className={classes[`${type}Cell`]} />;
  }

  return (
    <TableCell className={classes[`${type}Cell`]}>
      <div className={classes.cellContentCentered}>
        <p
          className={classes.unitBold}
          style={{ margin: 0 }}
        >
          {data === 0 ? '' : data}
          {data && data !== 0 && unit && <span className={classes.unitRegular}>&nbsp;{unit}</span>}
        </p>
      </div>
    </TableCell>
  );
};

const NutrientRow = ({ item, calculatedChange, showOnGreen, showOnRed, longDescription, type }) => {
  const classes = useStyles();
  const isFats = type?.trim().toLowerCase() === 'fats';

  // Determine if this is a limit nutrient
  const isLimitNutrient = Object.values(NUTRIENT_KEYS.nutrients).includes(item.key);

  // Convert string values to numbers
  const currentValue = Number(item.current) || 0;
  const goalValue = Number(item.goal) || 0;

  return (
    <TableRow className={classes.tableRow}>
      <TableCell className={classes.nutrientCell}>
        <NutrientItemTitle
          name={item.name}
          longDescription={longDescription}
        />
      </TableCell>
      {getCell({ data: item.current, unit: item.unit, type: 'current' })}
      {getCell({ data: item.goal, unit: item.unit, type: 'goal' })}
      {getCell({ data: calculatedChange, type: 'change' })}
      <TableCell className={classes.sliderCell}>
        <div className={classes.slidersContainer}>
          {!isFats && isLimitNutrient ? (
            <>
              <NutrientRangeSlider
                currentValue={currentValue}
                goalValue={goalValue}
                showIndicator={showOnGreen}
                type="green"
                isLimitNutrient={isLimitNutrient}
                name={item.name}
                unit={item.unit}
              />
              <NutrientRangeSlider
                currentValue={currentValue}
                goalValue={goalValue}
                showIndicator={showOnRed}
                type="red"
                isLimitNutrient={isLimitNutrient}
                name={item.name}
                unit={item.unit}
              />
            </>
          ) : !isFats ? (
            <>
              <NutrientRangeSlider
                currentValue={currentValue}
                goalValue={goalValue}
                showIndicator={showOnRed}
                type="red"
                isLimitNutrient={isLimitNutrient}
                name={item.name}
                unit={item.unit}
              />
              <NutrientRangeSlider
                currentValue={currentValue}
                goalValue={goalValue}
                showIndicator={showOnGreen}
                type="green"
                isLimitNutrient={isLimitNutrient}
                name={item.name}
                unit={item.unit}
              />
            </>
          ) : null}
        </div>
      </TableCell>
    </TableRow>
  );
};

export default NutrientRow;
